import { ApiError, requestJson, type ApiEnvelope } from '@shared/api/http';

function ensureSuccess<T>(body: ApiEnvelope<T>, fallbackMessage: string): ApiEnvelope<T> {
  if (body.status && body.status !== 'Success') {
    throw new ApiError(body.message ?? fallbackMessage, body.statusCode ?? 500, body);
  }
  return body;
}

export type ReportTargetType = 'user' | 'message' | 'article';

export type ReportReason =
  | 'harassment'
  | 'spam'
  | 'hate'
  | 'impersonation'
  | 'illegal'
  | 'other';

export const REPORT_REASON_LABELS: Record<ReportReason, string> = {
  harassment: '骚扰',
  spam: '垃圾信息',
  hate: '仇恨/歧视',
  impersonation: '冒充他人',
  illegal: '非法交易',
  other: '其他',
};

export async function submitReport(
  targetType: ReportTargetType,
  targetId: string,
  reason: ReportReason,
  detail?: string,
  baseUrl?: string,
): Promise<void> {
  const body = await requestJson<ApiEnvelope<unknown>>('/report/submit', {
    method: 'POST',
    baseUrl,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      targetType,
      targetId,
      reason,
      ...(detail ? { detail } : {}),
    }),
  });
  ensureSuccess(body, 'Failed to submit report');
}
